import {
  BulbOutlined,
  CopyOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { Button, Input, InputProps, InputRef } from "antd";
import { omit } from "lodash-es";
import { observer } from "mobx-react-lite";
import { forwardRef, Ref, useCallback, useState } from "react";

type TProps = InputProps & {
  onCopy?: () => void;
  onGenerate?: () => void;
};

function Password(props: TProps, ref: Ref<InputRef>) {
  const [isHidden, setIsHidden] = useState(true);

  const handleVisibilityChange = useCallback(() => {
    setIsHidden((prev) => !prev);
  }, []);

  const handleGenerateClick = useCallback(() => {
    setIsHidden(false);
    props.onGenerate?.();
  }, [props]);

  return (
    <Input.Group compact style={{ display: "flex", flexDirection: "row" }}>
      <Input
        ref={ref}
        {...omit(props, ["onCopy", "onGenerate"])}
        type={isHidden ? "password" : "text"}
        style={{ ...props.style, flex: 1 }}
        autoComplete="new-password"
        spellCheck={false}
        inputMode="text"
      />
      <Button
        icon={isHidden ? <EyeOutlined /> : <EyeInvisibleOutlined />}
        onClick={handleVisibilityChange}
        tabIndex={-1}
      />
      <Button icon={<CopyOutlined />} onClick={props.onCopy} tabIndex={-1} />
      <Button
        icon={<BulbOutlined />}
        onClick={handleGenerateClick}
        tabIndex={-1}
      />
    </Input.Group>
  );
}

export default observer(forwardRef(Password));
